import { render, staticRenderFns } from "./plusActivity.vue?vue&type=template&id=66cb39a0&scoped=true&lang=html"
import script from "./plusActivity.vue?vue&type=script&lang=js"
export * from "./plusActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cb39a0",
  null
  
)

export default component.exports